import { Link } from 'react-router-dom';
import Header from '../../../../components/Header';
import { useCourses } from '../../hooks/useCourses';
import { Course } from '../../../../types/course';

function CourseAdminCard({ course }: { course: Course }) {
  return (
    <div className="card">
      <div className="card-body" style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-md)' }}>
        <div style={{ flex: 1 }}>
          <h3 style={{ fontSize: 16, fontWeight: 600 }}>{course.title}</h3>
          {course.artist && (
            <p style={{ fontSize: 13, color: 'var(--color-text-secondary)' }}>{course.artist}</p>
          )}
          <p style={{ fontSize: 12, color: 'var(--color-text-muted)', marginTop: 'var(--space-xs)' }}>
            {course.capsules.length} capsules · slug: {course.slug}
          </p>
        </div>
        <div style={{ display: 'flex', gap: 'var(--space-sm)' }}>
          <Link
            to={`/admin/courses/edit?course=${course.slug}`}
            className="btn btn-sm btn-secondary"
          >
            Edit
          </Link>
          <Link
            to={`/courses/${course.slug}`}
            className="btn btn-sm btn-ghost"
          >
            View
          </Link>
        </div>
      </div>
    </div>
  );
}

export function CourseAdminListPage() {
  const { courses, loading, error } = useCourses();

  return (
    <>
      <Header />
      <div className="container" style={{ paddingTop: 'var(--space-xl)', paddingBottom: 'var(--space-2xl)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 'var(--space-xl)' }}>
          <h1 style={{ fontSize: 24, fontWeight: 700 }}>Manage Courses</h1>
          <Link to="/admin/courses/edit" className="btn btn-primary">
            + New Course
          </Link>
        </div>

        {loading && (
          <p style={{ color: 'var(--color-text-muted)', textAlign: 'center', padding: 'var(--space-2xl)' }}>
            Loading...
          </p>
        )}

        {error && (
          <p style={{ color: 'var(--color-incorrect)', textAlign: 'center', padding: 'var(--space-2xl)' }}>
            {error}
          </p>
        )}

        {!loading && !error && courses.length === 0 && (
          <div style={{ textAlign: 'center', padding: 'var(--space-2xl)', color: 'var(--color-text-muted)' }}>
            <p>No courses yet.</p>
            <Link to="/admin/courses/edit" style={{ color: 'var(--color-accent)', marginTop: 'var(--space-md)', display: 'inline-block' }}>
              Create your first course
            </Link>
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-sm)' }}>
          {courses.map((course) => (
            <CourseAdminCard key={course.id} course={course} />
          ))}
        </div>
      </div>
    </>
  );
}
